import { Handle, Position } from "@xyflow/react";

import { AnotherDateSelector } from "./AnotherDateSelector";
import { Box } from "@mui/material";
import { JobNodeArgsDisplay } from "./JobNodeArgsDisplay";
import { JobNodeHeader } from "./JobNodeHeader";
import { JobNodeInputs } from "./JobNodeInputs";
import { TrainedModelSelector } from "./TrainedModelSelector";

const NODE_HANDLE_STYLE = {
    background: "#555",
};

export function JobNode({
    data: {
        job,
        moduleVersion,
        disabled,
        missionUuid,
        experimentUuids,
        experimentCropUuid,
    },
}) {
    return (
        <Box>
            <Handle
                isConnectable={false}
                type="target"
                position={Position.Left}
                style={NODE_HANDLE_STYLE}
            />
            <JobNodeHeader job={job} moduleVersion={moduleVersion} />
            {job.trainedModelFilters && (
                <TrainedModelSelector
                    jobName={job.name}
                    trainedModelFilters={job.trainedModelFilters}
                    preExecArgs={job.preExec?.args}
                    experimentCropUuid={experimentCropUuid}
                    disabled={disabled}
                />
            )}
            {job.anotherDateSelection && (
                <AnotherDateSelector
                    jobName={job.name}
                    anotherDateSelection={job.anotherDateSelection}
                    preExecArgs={job.preExec?.args}
                    missionUuid={missionUuid}
                    experimentUuids={experimentUuids}
                    disabled={disabled}
                />
            )}
            <JobNodeInputs
                jobName={job.name}
                moduleVersionInputs={moduleVersion.definition.inputs}
                disabled={disabled}
                hiddenInputKeys={
                    job.anotherDateSelection
                        ? Object.keys(job.anotherDateSelection)
                        : undefined
                }
            />
            <JobNodeArgsDisplay
                jobName={job.name}
                moduleVersionInputs={moduleVersion.definition.inputs}
            />
            <Handle
                isConnectable={false}
                type="source"
                position={Position.Right}
                style={NODE_HANDLE_STYLE}
            />
        </Box>
    );
}
